<template>
  <v-dialog
    :value="isActive"
    @click:outside="closeDialog()"
    max-width="600"
    persistent
    transition="dialog-bottom-transition"
  >
    <ValidationObserver v-slot="{ handleSubmit }">
      <v-card>
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              {{ isEditMode ? "Actualizar Mensaje" : "Crear Mensaje" }}
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <ValidationProvider name="Titulo" rules="required" v-slot="{ errors }">
                  <v-text-field
                    v-model="payload.title"
                    placeholder="Título"
                    :error-messages="errors"
                    rounded
                    class="rounded-small"
                    filled
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <v-col cols="12">
                <ValidationProvider name="Mensaje" rules="required" v-slot="{ errors }">
                  <v-textarea
                    v-model="payload.text"
                    placeholder="Mensaje"
                    :error-messages="errors"
                    rounded
                    class="rounded-small"
                    filled
                  ></v-textarea
                ></ValidationProvider>
              </v-col>

              <v-col cols="12">
                <ValidationProvider rules="ext:png,jpg,jpeg|size:4000" name="imagen" v-slot="{ errors }">
                  <v-file-input
                    id="fileInput"
                    ref="fileInput"
                    filled
                    rounded
                    show-size
                    clearable
                    prepend-icon=""
                    hide-details
                    truncate-length="15"
                    class="rounded-small"
                    v-model="selectedFile"
                    accept="image/png, image/jpeg"
                    label="Adjuntar imagen..."
                    :error-messages="errors"
                    @change="verifyFile"
                  ></v-file-input>
                </ValidationProvider>
              </v-col>

              <v-col cols="12" class="my-0 py-0">
                <v-checkbox v-model="isAllAgents" label="Enviar a todos" color="primary"></v-checkbox>
              </v-col>

              <v-col cols="12" v-if="!isAllAgents">
                <ValidationProvider name="Usuarios" rules="required" v-slot="{ errors }">
                  <!-- {{ usersList }} -->
                  <v-select
                    :items="usersList"
                    v-model="payload.group"
                    item-text="name"
                    item-value="id"
                    placeholder="Usuarios"
                    :error-messages="errors"
                    multiple
                    chips
                    rounded
                    class="rounded-small"
                    filled
                  ></v-select>
                </ValidationProvider>
                <!-- {{ payload.group }} -->
              </v-col>

              <v-col cols="12">
                <v-select
                  :items="[1, 2, 3]"
                  v-model="payload.type"
                  placeholder="Tipo"
                  rounded
                  class="rounded-small"
                  filled
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>
        </vuescroll>
        <v-card-actions>
          <v-btn @click="closeDialog()" color="error" text>
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn @click="handleSubmit(submitForm)" class="px-5" color="success" rounded large>
            {{ isEditMode ? "Actualizar" : "Crear" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import vuescroll from "vuescroll";
export default {
  props: {
    isActive: {
      type: Boolean,
    },
    item: {
      type: Object,
    },
    isEditMode: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    vuescroll,
  },
  data() {
    return {
      isLoading: false,
      isAllAgents: false,
      payload: {
        type: 1,
        title: "",
        text: "",
        group: [],
      },
      usersList: [],
      tableOptions: {},
      totalEl: 0,
      selectedFile: null,
      fileExist: false,
    };
  },
  created() {
    this.getAgents();
    if (this.isEditMode) this.fillForm();
  },
  computed: {
    group() {
      return this.payload.group;
    },
  },
  watch: {
    // selectedFile(newValue) {
    //   console.log("entró");
    //   console.log(this.selectedFile);
    //   if (newValue) {
    //     console.log(this.newValue);
    //     // Crea una instancia de FormData y agrega el archivo
    //     const formData = new FormData();
    //     formData.append("file", newValue);

    //     // Actualiza el objeto payload con formData
    //     this.payload.file = formData;
    //     console.log(this.payload);
    //   }
    // },

    tableOptions: {
      handler() {
        this.getAgents();
      },
      deep: true,
    },
    // group(newVal) {
    //   if (Boolean(newVal.find((el) => el === 0) === 0) && newVal.length > 1) {
    //     this.payload.group = this.payload.group.filter((el) => el === 0);
    //   }
    // },
    group(newVal) {
      // Verifica si el valor 0 está presente en el arreglo y si el arreglo tiene más de un elemento
      if (newVal.includes(0) && newVal.length > 1) {
        // Filtra el arreglo para conservar solo el valor 0
        this.payload.group = this.payload.group.filter((el) => el === 0);
      }
    },
  },
  methods: {
    verifyFile() {
      if (this.fileSelected) {
        this.fileExist = true;
      } else {
        this.fileExist = false;
      }
    },

    selectAllAgents() {
      this.isAllAgents = !this.isAllAgents;
      this.payload.group = [];
    },
    fillForm() {
      this.payload.type = this.item.type;
      this.payload.text = this.item.text;
      this.payload.title = this.item.title;
    },
    closeDialog(itRefresh = false) {
      this.$emit("dialog:close", itRefresh);
    },
    submitForm() {
      this.isLoading = true;

      const formData = new FormData();
      // Agrega los otros campos al FormData
      formData.append("type", this.payload.type);
      formData.append("title", this.payload.title);
      formData.append("text", this.payload.text);
      formData.append("group", JSON.stringify(this.payload.group));
      if (this.selectedFile) {
        // Agrega el archivo al FormData
        formData.append("file", this.selectedFile);
      }

      const url = this.isEditMode ? `/admin/message/${this.item.id}` : "/admin/message";
      const method = this.isEditMode ? "put" : "post";

      PbxHttpClient[method](url, {
        ...this.payload,
      })
        .then(() => {
          const notifMsg = this.isEditMode ? "Mensaje actualizado con éxito." : "Mensaje creado con éxito.";
          this.$snotify.success(notifMsg, "¡Hecho!");
          this.closeDialog(true);
        })
        .catch(() => {
          const notifMsg = this.isEditMode
            ? "Hubo un error actualizando el mensaje"
            : "Hubo un error creando el mensaje";
          this.$snotify.error(notifMsg, "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async getAgents() {
      const page = this.tableOptions.page || 1;
      try {
        const { data } = await PbxHttpClient.get("/clients/show/agents_select", {
          params: { page },
        });
        this.usersList = data.data;
        this.totalEl = data.total;
      } catch (err) {
        console.log("error getting agents", err);
      }
    },
  },
};
</script>

<style></style>
